export enum Service {
  TOX = 'fcfef9cd-d52c-4168-bcbe-beaf2b9e2b49',
  TOX_IN_HOME = '567f3f90-585c-4485-bb60-bbba8ac5bd1e',
  TOX_EVENT = '96118629-fc8e-457c-a504-47a7dbb104c5',
  CHEM_PEEL = 'ebe3992e-1836-4313-9722-3152e5e2f640',
  CONSULTATION = '2d8c1de0-90a5-4589-97a6-e11a39f84a55',
  FILLER = 'f6c25e76-9adf-4f34-b2f6-38de4d68ccd1',
  ULTHERAPY = '6136a5df-a499-4ca7-bc8a-3fd23da14ba1',
  MICRONEEDLING = '0efc8f9d-287a-4944-86e2-c5d5a3365a64'
}

type ServiceViewModel = {
  label: string;
  description: string;
  serviceIds: Service[];
};

type ServicesViewModel = {
  [key in Service]?: ServiceViewModel;
};

export const servicesViewModel: ServicesViewModel = {
  [Service.TOX_IN_HOME]: {
    label: 'Tox',
    description: 'Reduce the appearance of fine lines and wrinkles in the comfort of your home or office.',
    serviceIds: [Service.TOX, Service.TOX_IN_HOME]
  },
  [Service.MICRONEEDLING]: {
    label: 'Microneedling',
    description: "Stimulate your body's own collagen production to reduce the appearance of scars and hyperpigmentation.",
    serviceIds: [Service.MICRONEEDLING]
  },
  [Service.CHEM_PEEL]: {
    label: 'Chemical Peel',
    description: "Go deeper than your daily skincare routine to treat fine lines and wrinkles, hyperpigmentation, acne scars, dark spots, and dullness.",
    serviceIds: [Service.CHEM_PEEL]
  },
  [Service.CONSULTATION]: {
    label: 'Skincare Consult',
    description: 'Not sure where to start? Get a personalized plan and recommendations from our expert, board-certified advanced practice providers.',
    serviceIds: [Service.CONSULTATION]
  },
  [Service.FILLER]: {
    label: 'Filler & Biostimulators',
    description: 'Enhance volume, contour, and hydration in areas including the cheeks, lips, jawline, and more',
    serviceIds: [Service.FILLER]
  },
  [Service.ULTHERAPY]: {
    label: 'Ultherapy',
    description: 'Ultherapy is the only non-invasive, FDA-approved skin tightening procedure that lifts the neck, chin and brow, and reduces lines and wrinkles on the upper chest.',
    serviceIds: [Service.ULTHERAPY]
  }
}